<template>
  <div class="app-container">
    <!--加载进度-->
    <van-loading v-if="!isLoaded" class="loading" />
    <!--加载失败-->
    <div v-else-if="errorMessage" class="error-message">
      错误：{{ errorMessage }}
    </div>
    <!--加载成功-->
    <template v-else>
      <van-cell class="application-info">
        <div>
          状态：{{ applicationInfo.status|applicationStatusName }}
        </div>
        <div>
          单号：{{ applicationInfo.businessNo }}
        </div>
      </van-cell>
      <process-steps :case-records="caseRecords" />
    </template>
  </div>
</template>

<script>
import { ApplicationStatus } from '@/utils/enums.js'
import { getApplicationInfo, getApplicationProcess } from '@/api/application'
import { ProcessSteps } from './components'

export default {
  components: {
    ProcessSteps
  },
  filters: {
    applicationStatusName: function(status) {
      return ApplicationStatus.getTextByValue(status)
    }
  },
  data() {
    return {
      isLoaded: false,
      errorMessage: '',
      applicationInfo: {},
      caseRecords: []
    }
  },
  created() {
    // 加载数据
    this.loadData()
  },
  methods: {
    // 加载数据
    async loadData() {
      // 申请信息id
      const id = this.$route.query.id || this.$route.params.id
      Promise.all([getApplicationInfo({ id }), getApplicationProcess(id)]).then(([response1, response2]) => {
        // 设置案卷信息
        this.applicationInfo = response1.data
        // 预受理案卷记录
        const caseRecords = response2.data
          .filter(caseRecord => !caseRecord.isExternal)
          .reverse()
        // 登记案卷记录
        const registrationCaseRecords = response2.data
          .filter(caseRecord => caseRecord.isExternal)
          .reverse()
          // 设置登记案卷记录为预受理案卷记录中登记环节的子流程
        const registrationCaseRecord = caseRecords.find(caseRecord => caseRecord.flowNode && caseRecord.flowNode.code === 'dj')
        if (registrationCaseRecord && registrationCaseRecords.length > 0) {
          registrationCaseRecord.children = registrationCaseRecords
        }
        this.caseRecords = caseRecords
      }).catch(error => {
        // 设置错误信息
        this.errorMessage = error.message
      }).finally(() => {
        // 设置加载状态为已加载
        this.isLoaded = true
      })
    }
  }
}
</script>

<style scoped lang="scss">
.app-container {
  .loading{
    padding-top: 15px;
    text-align: center;
  }
  .error-message{
    color: #ee0a24;
    padding-top: 15px;
    text-align: center;
  }
  .application-info{
    font-weight: 700;
  }
}
</style>
